import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_TIME_INTERVALS](state, data) {
    state.allTimeIntervals = data
  },
}
